var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLangImg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 14,
    viewBox: "0 0 13 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.51515 4.93937H11.8182M6.66667 12.6666C9.79621 12.6666 12.3333 10.1295 12.3333 6.99998C12.3333 3.87043 9.79621 1.33331 6.66667 1.33331C3.53712 1.33331 1 3.87043 1 6.99998C1 10.1295 3.53712 12.6666 6.66667 12.6666ZM6.66667 12.6666C8.21212 12.6666 8.72727 10.0909 8.72727 6.99998C8.72727 3.90907 8.21212 1.33331 6.66667 1.33331C5.12121 1.33331 4.60606 3.90907 4.60606 6.99998C4.60606 10.0909 5.12121 12.6666 6.66667 12.6666ZM1.51515 9.06059H11.8182H1.51515Z",
    stroke: "#333333",
    strokeWidth: 1.3
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLangImg);
export default __webpack_public_path__ + "static/media/langImg.cedaadae1ee1bf21caa6d034b4547bf5.svg";
export { ForwardRef as ReactComponent };